import { render, staticRenderFns } from "./TransactionsPayments.vue?vue&type=template&id=18f44abb&"
import script from "./TransactionsPayments.vue?vue&type=script&lang=js&"
export * from "./TransactionsPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports